"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var main_1 = require("../../themes/main");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var backgroundColor = _a.backgroundColor, color = _a.color, type = _a.type;
            return ({
                backgroundColor: type === 'error' ? main_1.materialColors.red[700] : backgroundColor,
                color: color,
                display: 'flex',
                alignItems: 'center',
                padding: "".concat(theme.spacing(1.5), "px ").concat(theme.spacing(2), "px"),
                height: 52,
                borderTopLeftRadius: 52 / 2,
                borderBottomLeftRadius: 52 / 2,
            });
        },
        icon: {
            marginTop: 2,
            marginRight: theme.spacing(1),
        },
        snackbar: function (_a) {
            var withFab = _a.withFab;
            return ({
                top: withFab ? 195 : undefined,
                height: 52,
                '&.MuiSnackbar-anchorOriginBottomRight': {
                    right: 0,
                },
            });
        },
    });
});
